var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{staticClass:"d-inline-block ml-4",style:({ flex: '0 0 auto', maxWidth: 'none' }),attrs:{"src":_vm.resHubLogoUrl,"height":_vm.numHeight,"width":_vm.computedWidth,"contain":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }